import { Injectable } from "@angular/core";
import {
    MatSnackBar,
    MatSnackBarHorizontalPosition,
    MatSnackBarVerticalPosition,
  } from '@angular/material/snack-bar';
import { SnackBarComponent } from "../components/snack-bar.component";

@Injectable({
    providedIn: 'root',
})
export class SnackBarService {

    horizontalPosition: MatSnackBarHorizontalPosition = 'end';
    verticalPosition: MatSnackBarVerticalPosition = 'top';

    constructor(private _snackBar: MatSnackBar) {}

    public success(text: string, buttonName?: string): void {
      this._snackBar.openFromComponent(SnackBarComponent, {
        horizontalPosition: this.horizontalPosition,
        verticalPosition: this.verticalPosition,
        duration: 2000,
        data: { text: text, type: 'success', buttonName: buttonName },
        panelClass: 'success'
      });
    }

    public warning(text: string, buttonName?: string): void {
      this._snackBar.openFromComponent(SnackBarComponent, {
        horizontalPosition: this.horizontalPosition,
        verticalPosition: this.verticalPosition,
        duration: 2000,
        data: { text: text, type: 'warning', buttonName: buttonName },
        panelClass: 'warning'
      });
    }

    public danger(text: string, buttonName?: string): void {
      this._snackBar.openFromComponent(SnackBarComponent, {
        horizontalPosition: this.horizontalPosition,
        verticalPosition: this.verticalPosition,
        duration: 2000,
        data: { text: text, type: 'danger', buttonName: buttonName },
        panelClass: 'danger'
      });
    }
}